<template>
	<md-table>
		<md-table-row v-for="(member, index) in members" :key="member+index">
			<md-table-cell>
				<font-awesome-icon class='selector' v-if="selected.indexOf(member._id) < 0" icon="square" @click="toggle(member)" v-show="admin ? selected.length < 30 - admin.length ? true : false : true" />
				<font-awesome-icon class='selector' v-if="selected.indexOf(member._id) >= 0" icon="check-square" @click="toggle(member)" />
			</md-table-cell>
				<!--<member :member="member">Advisors goes here...</member>-->
				<!-- <md-table-cell>
				<md-avatar class="md-medium">
					<img v-if="member && member.imageURL" :src="member.imageURL" class="user-image">
					<img v-if="!member || !member.imageURL" class="user-image" src="../assets/person.png">
				</md-avatar>
				</md-table-cell> -->
				<md-table-cell class="capitalize"><span class="display-link" @click="goToProfile(member)">{{displayName(member)}}</span></md-table-cell>
				<md-table-cell>{{ member.emails[0] }}</md-table-cell>
		</md-table-row>
		</md-table>
</template>
<!-- Script-->
<script>
import Member from "./Member";
export default {
  	components: {
    	Member
	},
	props: ["members", "selected", "admin", "iconName"],
	mounted() {
		this.selected.length = 0;
    },
  	methods: {
    	toggle: function(member) {
			if (!this.admin && this.iconName !== 'undefined' && (this.iconName === 'Member' || this.iconName === 'Search adviser')) {
				this.selected.length = 0;
			}
      		if (this.selected.indexOf(member._id) >= 0) {
        	this.selected.splice(
          	this.selected.indexOf(member._id),
          	1
        	);
      	} else {
        	this.selected.push(member._id);
      	}
      	this.$emit("changed", this.selected);
    	},
    	displayName(member) {
  			return this.$lodash.has(member, 'first') ? member.first + ' ' + member.last : member.displayName;
  		},
  		goToProfile: function(member) {
  	  		let route = this.$router.resolve({path: `/members/${member._id}`});
      		window.open(route.href, '_blank');
    	}
  	}
};
</script>

<style scoped>
	/*
	table td.member {
		width: 500px;
	}
	*/
	table td {
		text-align: left;
	}
</style>



// WEBPACK FOOTER //
// src/components/MultiMemberPicker.vue